import React from 'react';
import { Link } from 'react-router-dom';
import { heroArtwork } from '../../../data/heroArtwork';
import { useLanguage } from '../../../contexts/LanguageContext';
import { MenuButton } from '../../layout/MenuButton';
import { ShopNowButton } from '../../shop/ShopNowButton';
import { WarrantyBanner } from '../../shop/WarrantyBanner';
import { HoloBanner } from './HoloBanner';
const pct = (v: number, total: number) => `${v / total * 100}%`;

/** Phones and tablets: vertical artwork with SHOP NOW placed on it, under the product. */
export function HeroMobile() {
  const {
    t
  } = useLanguage();
  const {
    mobile
  } = heroArtwork;
  const {
    width: W,
    height: H
  } = mobile;
  return <div className="lg:hidden" data-id="element-128" data-mp="2lo8slxk5pp25">
      <div className="relative mx-auto w-full sm:max-w-[560px]" data-id="element-129" data-mp="2lpa0jt5vlvfn">
        <img src={mobile.src} width={W} height={H} alt={heroArtwork.alt} loading="eager" decoding="async" className="block h-auto w-full" data-id="element-130" data-mp="exj02ljhu62g" />
        <h1 className="sr-only" data-id="element-131" data-mp="fd9ivlmf4l9j">
          {t('hero.headline')} {t('hero.brand')}
        </h1>

        {/* Poster carries the logo — only the live menu is overlaid. */}
        <MenuButton className="absolute right-3 top-3 bg-[#030A14]/55 backdrop-blur-sm" data-id="element-132" data-mp="p3kvrxo2y4sk" />

        {/* The artwork's M1 PRO links to the product page. */}
        <Link to="/m1-pro" aria-label="Explore the M1 PRO" className="absolute rounded-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ice" style={{
        left: pct(mobile.product.x, W),
        top: pct(mobile.product.y, H),
        width: pct(mobile.product.w, W),
        height: pct(mobile.product.h, H)
      }} data-id="element-133" data-mp="k59l5kpynq9a" />

        {/* SHOP NOW — centered under the product, just above the technical strip. */}
        <div className="absolute -translate-x-1/2" style={{
        left: pct(mobile.shopNow.cx, W),
        bottom: pct(H - mobile.shopNow.bottom, H)
      }} data-id="element-134" data-mp="1ctf7ud0krpbr">
          <ShopNowButton source="hero-mobile" className="!h-[clamp(44px,11vw,56px)] !px-[clamp(18px,5vw,28px)] !text-[clamp(14px,3.8vw,17px)]" data-id="element-135" data-mp="9i9gye798414" />
        </div>
      </div>

      <div className="mx-auto w-full sm:max-w-[560px]" data-id="element-136" data-mp="jhgrktmltkkj">
        <HoloBanner data-id="element-137" data-mp="nikaxq3v1yqi" />
        <WarrantyBanner data-id="element-138" data-mp="ngzh62pdejtp" />
      </div>
    </div>;
}